module.exports = __webpack_public_path__ + "static/media/udemy-logo.86f439c0.png";